// ======== core Vue
import Vue from "vue";

// ======== Main app
import App from "./App.vue";

// ======== Router
import router from "./router";

// ======== Store
import store from "./store";

// ======== language
store.dispatch("lang_module/handleLang"); // ==> Store (Vuex) <==
store.dispatch("theme_module/handleTheme"); // ==> Store (Vuex) <==

// ======== Cv Steps
// store.dispatch("cv_module/handleStep"); // ==> Store (Vuex) <==

// ========  Start Axios
import axios from "axios";

Vue.prototype.$axios = axios; // Glopal variable

// Global headers
// axios.defaults.baseURL = "http://sas.develobug.com/api/"; // baseurl
axios.defaults.baseURL = "https://sas-jobs.net/api/";// baseurl
//axios.defaults.baseURL = "http://127.0.0.1:8000/api/"; // baseurl

axios.defaults.headers.common["cache-control"] = "no-cache";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["lang"] =
    store.getters["lang_module/lang"]; // ==> Store (Vuex) <==

// Set Token If Exists
if (store.getters["auth_module/token"]) {
    axios.defaults.headers.common["Authorization"] =
        "bearer" + localStorage.getItem("SAS_App_Token");
}
// ========  End Axios

// ======== Bootstrap
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
Vue.use(BootstrapVue);

// ======== iziToast
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
Vue.prototype.$iziToast = iziToast; // Glopal variable
Vue.use(iziToast);

// ======== Moment
const moment = require("moment");
// if (store.getters["lang_module/lang"] == "ar") {
//     require("moment/locale/ar");
// }
Vue.use(require("vue-moment"), {
    moment,
});

// ======== AOS
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

//=====SOCIAL SHARE 
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);

// ======== i18n
import i18n from "./i18n";

// ======= vuetify
import vuetify from "./plugins/vuetify";

// =============> Vue Slike Carousal
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

// ========  Main Style
import "./assets/scss/main.scss";

// =============> Country Code
import VueCountryCode from "vue-country-code-select";

Vue.use(VueCountryCode);

// =============> Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: "AIzaSyB4DDathvvwuwlwnUu7F4Sow3oU22y5T1Y",
        libraries: "places", // This is required if you use the Auto complete plug-in
    },
});

//Loader
import Loader from "./components/Loaders/Loader.vue";
Vue.component("loader", Loader);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

// Import Globbal Components

//==== Register Globbal Components
//Slick Slider
Vue.component("vue-slick", VueSlickCarousel);

//Owl Carusel
import carousel from 'vue-owl-carousel';
Vue.component("owl-slider", carousel);

//BaseModel
import BaseModel from "./components/UI/BaseModel.vue";
Vue.component("base-model", BaseModel);

//Not Found
import NotFound from "./components/Global/NotFound.vue";
Vue.component("not-found", NotFound);

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
  })

// ======== Mixins
import helpers from "./globalHelpers";
Vue.mixin(helpers);

// ======== Attatch and Mount
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");